/**
 * Registration form password visibility toggle
 * Specifically for the registration page password fields
 */
document.addEventListener('DOMContentLoaded', function() {
  // Find the password toggle buttons on the registration form
  const passwordToggle = document.querySelector('#RegisterForm-password').parentNode.querySelector('.password-toggle');
  const confirmToggle = document.querySelector('#RegisterForm-password-confirm').parentNode.querySelector('.password-toggle');
  
  // Function to toggle password visibility
  function togglePasswordVisibility(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const wrapper = button.closest('.password-input-wrapper');
    const passwordInput = wrapper.querySelector('input[type="password"], input[type="text"]');
    
    // Toggle the password field type between "password" and "text"
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      button.classList.add('active');
    } else {
      passwordInput.type = 'password';
      button.classList.remove('active');
    }
  }
  
  // Add click event listeners to the toggle buttons
  if (passwordToggle) {
    passwordToggle.addEventListener('click', togglePasswordVisibility);
  }
  
  if (confirmToggle) {
    confirmToggle.addEventListener('click', togglePasswordVisibility);
  }
});
